import { render } from "./CatalogPickerComponent.vue?vue&type=template&id=4680b14f&scoped=true&ts=true"
import script from "./CatalogPickerComponent.vue?vue&type=script&lang=ts"
export * from "./CatalogPickerComponent.vue?vue&type=script&lang=ts"

import "./CatalogPickerComponent.vue?vue&type=style&index=0&id=4680b14f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4680b14f"]])

export default __exports__